<div class="wrapper d-flex flex-column">
  <label>{{'Time' | translate}}</label>
  <div class="d-flex flex-row">
    <ngb-timepicker
      #time
      [(ngModel)]="newTime"
      [disabled]="saving"
      [spinners]="false"
      required
    ></ngb-timepicker>
    <div class="input-group w-auto">
      <input
        #date="ngbDatepicker"
        type="text"
        [(ngModel)]="newDate"
        ngbDatepicker
        [disabled]="saving"
        [minDate]="newMinDate"
        class="form-control ml-3"
        required
      >
      <div class="input-group-append">
        <button class="btn btn-outline-primary" (click)="date.toggle()" type="button">
          <i class="fas fa-calendar"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="d-flex flex-row mt-2">
    <a
      *ngFor="let minutes of timeAddIntervals"
      href="#"
      class="badge badge-pill badge-primary mr-1 increment-time-button"
      (click)="$event.preventDefault(); !saving && onIncrementTimeClick(minutes); $event.target.blur()"
      readonly
    >
      +{{minutes}}
    </a>
  </div>

  <label class="mt-3">{{'Message' | translate}}</label>
  <input
    type="text"
    #description
    [(ngModel)]="newDescription"
    [disabled]="saving"
    (keydown.enter)="onSaveClick()"
    minlength="1"
    required
  >

  <div class="d-flex flex-row align-items-center justify-content-end">
    <div *ngIf="this.newError" class="flex-grow-1 text-danger">{{this.newError | translate}}</div>
    <ng-container *ngIf="this.editedReminder; else noEditedReminder">
      <button type="button" class="btn btn-link" (click)="onClearClick()" [disabled]="saving">
        <i class="fas fa-times"></i> {{'Cancel' | translate}}
      </button>
      <button type="button" class="btn btn-link" (click)="onSaveClick()" [disabled]="saving">
        <i class="fas fa-plus-circle"></i> {{'Save' | translate}}
      </button>
    </ng-container>
    <ng-template #noEditedReminder>
      <button type="button" class="btn btn-link" (click)="onClearClick()" [disabled]="saving">
        <i class="fas fa-times"></i> {{'Clear' | translate}}
      </button>
      <button type="button" class="btn btn-link" (click)="onSaveClick()" [disabled]="saving">
        <i class="fas fa-plus-circle"></i> {{'Add' | translate}}
      </button>
    </ng-template>
  </div>

  <h5>{{'Upcoming' | translate}}</h5>

  <div class="upcoming-reminders flex-grow-1 mb-2">
    <table *ngIf="(reminders$ | async).length > 0; else noReminders" class="table table-sm">
      <tbody>
        <tr
          *ngFor="let reminder of reminders$ | async"
          [ngClass]="{
            'table-active': editedReminder && editedReminder.backendReminder.id === reminder.backendReminder.id
          }"
        >
          <td>{{reminder.backendReminder.alarmingTime | qmDateFormat:'HH:mm'}}</td>
          <td>{{reminder.backendReminder.alarmingTime | qmDateFormat:'dd.MM.yyyy'}}</td>
          <td class="description-cell">{{reminder.backendReminder.description}}</td>
          <td class="action-cell text-right">
            <button type="button" class="btn btn-link btn-sm" (click)="onEditClick(reminder)" ngbTooltip="{{'Edit' | translate}}">
              <i class="fas fa-file-edit"></i>
            </button>
            <button type="button" class="btn btn-link btn-sm" (click)="onDeleteClick(reminder)" ngbTooltip="{{'Delete' | translate}}">
              <i class="fas fa-minus-circle"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #noReminders>
      <p>{{'No upcoming reminders.' | translate}}</p>
    </ng-template>
  </div>
</div>
